import moment from 'moment';

export const ALL_TIME_DATE = moment('2001-01-01');
export const ALL_TIME_DATE_STRING = ALL_TIME_DATE.format('YYYY-MM-DD');
